import {AfterViewInit, Component, HostBinding, Input, OnInit, TemplateRef, ViewChild, inject} from '@angular/core';
import { FilteringLogic, IgxStringFilteringOperand } from '@infragistics/igniteui-angular/core';
import {
  IGridEditDoneEventArgs, IGridEditEventArgs, IgxColumnComponent, IgxExcelExporterService, IgxPdfExporterService,
  IgxGridCell, IgxGridStateDirective, RowType
} from '@infragistics/igniteui-angular/grids/core';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import { IgxButtonDirective, IgxButtonModule, IgxFocusDirective, IgxRippleDirective, IgxRippleModule, IgxTextSelectionDirective } from '@infragistics/igniteui-angular/directives';
import {IGX_INPUT_GROUP_DIRECTIVES, IgxInputGroupComponent} from '@infragistics/igniteui-angular/input-group';
import { IGX_ACTION_STRIP_DIRECTIVES, IgxActionStripModule } from '@infragistics/igniteui-angular/action-strip';
import {ClsConfig} from '../../../util/cls-config';
import {MasOpcionesGridComponent} from '../../util/controles/mas-opciones-grid/mas-opciones-grid.component';
import {ClsUtil} from '../../../util/cls-util';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {ClsObjCrudCatalogos} from '../../../clases-pu/02-catalogos/cls-obj-crud-catalogos';
import {EnumMasOpciones} from '../../../core/models/enum/enum-mas-opciones';
import {INeodataGridCell, INeodataMenu} from '../../../core/models/interfaces/generico-interface';
import {EnumMCGenerales} from '../../../core/models/enum/enum-menu-contextual';
import {EnumNombresGrids} from '../../../core/models/enum/enum-nombres-grids';
import {ClsObjConfiguracionGrid} from '../../../clases-pu/util/cls-obj-configuracion-grid';
import {ClsObjGenerico} from '../../../clases-pu/util/cls-obj-generico';
import {EnumTresPuntos} from '../../../core/models/enum/enum-tres-puntos';
import {ClsObjCopiado} from '../../../clases-pu/01-presupuesto/copiado/cls-obj-copiado';
import {DetallePegadoComponent} from '../../util/ventanas/detalle-pegado/detalle-pegado.component';
import {VtnGenericaComponent} from '../../util/ventanas/vtn-generica/vtn-generica.component';
import {FiltroGeneralModernoComponent} from '../../util/controles/filtro-general-moderno/filtro-general-moderno.component';
import {ClsObjPegado} from '../../../clases-pu/99-herramientas/pegado/cls-obj-pegado';
import {TranslateModule} from '@ngx-translate/core';
import {ContextMenuGenericoComponent} from '../../util/controles/context-menu-generico/context-menu-generico.component';
import {FormsModule} from '@angular/forms';
import {PasteHandlerNeodataDirective} from '../../../core/directivas/paste-handler-neodata.directive';
import {ClsTipoInsumos} from "../../../core/models/cls-catalogos";
import {ClsColDetallePegado} from "../../../core/models/cls-pegado";
import {TipoMensajesService} from "../../../core/services/tipo-mensajes.service";
import {SummaryPipeNeoPipe} from "../../../core/pipes/summary-pipe-neo.pipe";
import {CrearComponenteDinamicoService} from "../../../core/services/crear-componente-dinamico.service";

@Component({
  selector: 'app-tiposdeinsumos',
  templateUrl: './tipos-de-insumos.component.html',
  styleUrls: ['./tipos-de-insumos.component.scss'],
  imports: [
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    TranslateModule,
    FiltroGeneralModernoComponent,
    IgxIconComponent,
    PasteHandlerNeodataDirective,
    MasOpcionesGridComponent,
    IGX_INPUT_GROUP_DIRECTIVES,
    IgxButtonModule,
    IgxButtonDirective,
    IgxActionStripModule,
    IGX_ACTION_STRIP_DIRECTIVES,
    FormsModule,
    IgxFocusDirective,
    IgxTextSelectionDirective,
    IgxRippleModule,
    IgxRippleDirective,
    ContextMenuGenericoComponent,
    SummaryPipeNeoPipe,
    IgxInputGroupComponent
  ],
  providers: [SummaryPipeNeoPipe]
})
export class TiposDeInsumosComponent extends ClsConfig implements OnInit, AfterViewInit {
  private infPpto = inject(AppPresupuestosService);
  private tipoMsg = inject(TipoMensajesService);
  private summaryPipe = inject(SummaryPipeNeoPipe);
  private excelExportService = inject(IgxExcelExporterService);
  private pdfExportService = inject(IgxPdfExporterService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);

  @ViewChild('gridTiposInsumos', {read: IgxGridComponent, static: true})
  public gridTiposInsumos: IgxGridComponent;
  @ViewChild('masOpcionesG', {read: MasOpcionesGridComponent, static: true})
  public masOpcionesG: MasOpcionesGridComponent;
  @ViewChild('filtroGeneral', {read: FiltroGeneralModernoComponent, static: true})
  public filtroGeneral: FiltroGeneralModernoComponent;
  @Input()
  public modoEdicion = true;
  // ajuste de texto
  @HostBinding('class') public themesClass = 'noAjustarTexto';
  public clicked = false;

  public errorAlCargar: boolean;
  public dataTipoInsumos: ClsTipoInsumos[] = [];
  public activarBotones = false;
  private isAddRow = false;
  // mostrar actionStrip
  public showActionStrip = true;
  // clase catalogos
  public mObjCRUDCatalogos: ClsObjCrudCatalogos = new ClsObjCrudCatalogos();
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();
  private mObjCopiado: ClsObjCopiado = new ClsObjCopiado();
  private mObjPegado: ClsObjPegado = new ClsObjPegado();
  // menucontextual
  public verContextMenu = false;
  public contextmenuX = 0;
  public contextmenuY = 0;
  public cellMenuContextaul: IgxGridCell;
  public menus: INeodataMenu[] = [];
  public lengthMenu: number;
  public subMenusOpciones: any[];
  public sizeMenu = '';
  // CONFIGGRIDS: definir cada ng-Template que tengamos en el HTML
  @ViewChild('tipoInsumoHeaderTemplate', {static: true}) public tipoInsumoHeaderTemplate: TemplateRef<any>;
  @ViewChild('descripcionTipoInsumoHeaderTemplate', {static: true}) public descripcionTipoInsumoHeaderTemplate: TemplateRef<any>;
  @ViewChild('descripcionTipoInsumoEditorTemplate', {static: true}) public descripcionTipoInsumoEditorTemplate: TemplateRef<any>;
  @ViewChild(IgxGridStateDirective, {static: true}) public state;
  // bloqueo de celdas por CSS
  public backgroundClasses = {
    highlighted: (rowData: any, columnKey: any, cellValue: any, rowIndex: any) => {
      if ((columnKey === 'DescripcionTipoInsumo') && (rowData.TipoInsumo > 0 && rowData.TipoInsumo < 4)) {
        return rowData;
      }
    },
  };
  // Grid Layout
  public mObjConfigGrids: ClsObjConfiguracionGrid = new ClsObjConfiguracionGrid();
  // ConfigGridLayout
  public optionsGridLocal = {
    cellSelection: true,
    rowSelection: false,
    filtering: false,
    advancedFiltering: true,
    paging: true,
    sorting: false,
    groupBy: true,
    columns: true,
    expansion: true,
    rowPinning: false,
    columnSelection: true
  };
  public vtnGenerico: VtnGenericaComponent;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.gridTiposInsumos.data = [];
  }

  public ngAfterViewInit() {
    // se genera la plantilla default del grid
    const stateDefault = this.state.getState(true);

    this.mObjConfigGrids.saveGridState(EnumNombresGrids.TipoInsumos, true, stateDefault, '', this.clicked);
    const state = this.mObjConfigGrids.initGridState(EnumNombresGrids.TipoInsumos);
    if (!ClsUtil.esNulo(state[0])) {
      this.state.setState(state[0]);
    }
    this.clicked = state[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
  }

  public onColumnInit(column: IgxColumnComponent) {
    switch (column.field) {
      case 'TipoInsumo':
        column.headerTemplate = this.tipoInsumoHeaderTemplate;
        column.cellStyles = this.cellStyles;
        break;
      case 'DescripcionTipoInsumo':
        column.headerTemplate = this.descripcionTipoInsumoHeaderTemplate;
        column.inlineEditorTemplate = this.descripcionTipoInsumoEditorTemplate;
        column.summaries = this.summaryPipe.transform('filasSummary');
        column.cellClasses = this.backgroundClasses;
        break;
    }
  }

  public async cargarTiposDeInsumos() {
    if (!ClsUtil.esNulo(this.infPpto.organizacion)) {
      try {
        this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.GET_CATALOGOS');
        this.mObjCRUDCatalogos.dataCatalogo = [];
        this.dataTipoInsumos = [];
        await this.mObjCRUDCatalogos.obtenerCatalogo(0, 'ConsultarTipoInsumos2021');
        this.mObjCRUDCatalogos.dataCatalogo.forEach(tipo => {
          const tipoInsumo2: ClsTipoInsumos = {
            IdTipoInsumo: tipo.TipoInsumo,
            TipoInsumo: tipo.TipoInsumo,
            DescripcionTipoInsumo: tipo.DescripcionTipoInsumo
          };
          this.dataTipoInsumos.push(tipoInsumo2);
        });
        this.gridTiposInsumos.data = this.dataTipoInsumos;
        this.errorAlCargar = false;
        this.tipoMsg.cerrarWaitDialog();
      } catch (e) {
        this.tipoMsg.cerrarWaitDialog();
        this.errorAlCargar = true;
        this.tipoMsg.mostrarMsg(e.message, 'error');
      }
    }
  }

  public menuContextual(evt: any) {
    evt.event.preventDefault();
    this.disableContextMenu();
    this.disableAllContextMenu();
    this.menus = this.mObjCRUDCatalogos.crearMenuContextual({
      esCliente: false,
      esUnidad: false,
      esEmpresa: false
    }, this.infPpto.esPptoMaestro);
    this.subMenusOpciones = [];
    this.lengthMenu = this.menus.filter(x => !x.disabled).length;
    this.contextmenuX = ClsUtil.calcPosition(document.body.clientWidth, evt.event.clientX, true, this.lengthMenu);
    this.contextmenuY = ClsUtil.calcPosition(document.body.clientHeight, evt.event.clientY, false, this.lengthMenu);
    this.sizeMenu = (this.lengthMenu * 37) + 'px';
    this.cellMenuContextaul = evt.cell;
    this.verContextMenu = true;
  }

  public disableContextMenu() {
    if (this.verContextMenu) {
      this.verContextMenu = false;
    }
  }

  public disableAllContextMenu() {
    this.mObjGenerico.disableAllContextMenu(this.infPpto);
  }

  public async accionSeleccionada(evt: INeodataGridCell) {
    try {
      switch (evt.accionMenu.id) {
        case EnumMCGenerales.Copiar:
          await this.copiarData();
          break;
        case EnumMCGenerales.Pegar:
          let data: any = await navigator.clipboard.readText().then((data2) => data2);
          data = this.pasteHandlerNeo.processData(data);
          await this.datosPegadosDesdeExcel(data);
          break;
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMCGenerales.GuardarLayout:
          const state = this.state.getState(true);
          this.mObjConfigGrids.saveGridState(EnumNombresGrids.TipoInsumos, false, '', state, !this.clicked);
          break;
        case EnumMCGenerales.ReestablecerLayout:
          this.restoreGrid();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public restoreGrid() {
    const stateDefault = this.mObjConfigGrids.restoreGrid(EnumNombresGrids.TipoInsumos);
    if (!ClsUtil.esNulo(stateDefault[0])) {
      this.state.setState(stateDefault[0]);
    }
    this.clicked = stateDefault[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
  }

  public clearInput() {
    this.filtroGeneral.input.value = '';
    this.gridTiposInsumos.clearFilter();
  }

  public filterInput(filtro: string) {
    this.gridTiposInsumos.filteringLogic = FilteringLogic.Or;
    this.gridTiposInsumos.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'));
  }

  public rowEditEnter(evt: IGridEditEventArgs) {
    this.isAddRow = evt.isAddRow;
    this.showActionStrip = false;
  }

  public cellEditEnter(evt: IGridEditEventArgs) {
    if (!this.isAddRow) {
      if (evt.column.field === 'TipoInsumo' || (evt.rowData.TipoInsumo > 0 && evt.rowData.TipoInsumo < 4)) {
        evt.cancel = true;
      }
    }
  }

  public rowEditExit() {
    this.showActionStrip = true;
  }

  // evento que se ocupa para guardar o modificar
  public async addUpdateTipoInsumo(tipoInsumo: IGridEditDoneEventArgs) {
    const newValor: ClsTipoInsumos = tipoInsumo.newValue;
    const oldValor: ClsTipoInsumos = tipoInsumo.oldValue;
    if (tipoInsumo.isAddRow) {
      await this.agregarModificarTipoInsumo(newValor, oldValor, tipoInsumo.isAddRow);
    } else {
      // al editar los campos, validar que sean distintos para ocupar el servicio
      if (this.mObjCRUDCatalogos.validarSiCambioCamposCatalogos(newValor, oldValor, EnumTresPuntos.TiposDeInsumo)) {
        await this.agregarModificarTipoInsumo(newValor, oldValor, tipoInsumo.isAddRow);
      }
    }
  }

  private async agregarModificarTipoInsumo(newTipoInsumos: ClsTipoInsumos, oldTipoInsumos: ClsTipoInsumos, isAddRow: boolean) {
    let respuesta: any;
    const objCatalogo: ClsTipoInsumos = new ClsTipoInsumos();
    try {
      objCatalogo.TipoInsumo = newTipoInsumos.TipoInsumo;
      objCatalogo.DescripcionTipoInsumo = newTipoInsumos.DescripcionTipoInsumo;
      this.tipoMsg.mostrarWaitDialog(isAddRow ? 'MENSAJES.WAIT.GUARDANDO_CATALOGO' : 'MENSAJES.WAIT.MODIFICANDO_CATALOGO');
      respuesta = await this.mObjCRUDCatalogos.agregarModificarCatalogo([objCatalogo], 'TipoInsumosRegistraActualiza2021');
      this.tipoMsg.mostrarToast(isAddRow ? 'MENSAJES.TOAS.GUARDANDO_CATALOGO' : 'MENSAJES.TOAS.MODIFICANDO_CATALOGO');
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.cancelarAddUpdateTipoInsumo(newTipoInsumos, oldTipoInsumos, isAddRow);
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa cuando manda error al intentar agregar o modificar,
  // al agregar si manda error se quita la fila del grid
  // al editar si manda error se regresa a los valores anteriores
  private cancelarAddUpdateTipoInsumo(newTipoInsumos: ClsTipoInsumos, oldTipoInsumos: ClsTipoInsumos, isAddRow: boolean) {
    if (isAddRow) {
      this.gridTiposInsumos.deleteRowById(newTipoInsumos.IdTipoInsumo);
    } else {
      this.gridTiposInsumos.updateRow(oldTipoInsumos, oldTipoInsumos.IdTipoInsumo);
    }
  }

  private async eliminarTipoInsumos(rowContext: RowType) {
    const tipoInsumo: ClsTipoInsumos = rowContext.data;
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.ELIMINANDO_CATALOGO', undefined, 'delete');
      await this.mObjCRUDCatalogos.eliminarCatalogo(tipoInsumo.TipoInsumo, 'EliminarTipoInsumos2021');
      this.gridTiposInsumos.getRowByIndex(rowContext.index).delete();
      this.tipoMsg.mostrarToast('MENSAJES.TOAS.ELIMINANDO_CATALOGO');
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public async edicionCelda(event: IGridEditEventArgs) {
    const newValue: any = event.newValue;
    try {
      switch (event.column.field) {
        case 'TipoInsumo':
          if (Number(newValue <= 0)) {
            event.cancel = true;
            throw new Error('MENSAJES.ALERT.TIPO_INSUMO_NO_VALIDO');
          }
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa el evento rowEdit para validar uno o varios campos obligatorios,
  // si falta algun campo de todo la fila se cancela la edicio y se manda mensaje que campos faltan
  // en caso de ser todo OK, procede al agregado o modificado
  public validarTipoInsumo(tipoInsumo: IGridEditEventArgs) {
    const valor: ClsTipoInsumos = tipoInsumo.newValue;
    tipoInsumo.cancel = this.esValido(valor, tipoInsumo, tipoInsumo.isAddRow);
  }

  private esValido(tipoInsumos: ClsTipoInsumos, tInsumo: any, isAddRow: boolean): boolean {
    // validar campos obligatorios
    if (ClsUtil.esNulo(tipoInsumos.TipoInsumo)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.TIPOS_INSUMOS.COL_TIPO')));
      return true;
    }
    if (ClsUtil.esNulo(tipoInsumos.DescripcionTipoInsumo)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.TIPOS_INSUMOS.COL_DESCRIPCION')));
      return true;
    }
    if (tipoInsumos.TipoInsumo <= 0) {
      this.tipoMsg.mostrarMsg('MENSAJES.ALERT.TIPO_INSUMO_NO_VALIDO');
      return true;
    }
    // valida si ya existe la empresa cuando se agrega o modifica
    if (isAddRow) {
      if (this.dataTipoInsumos.findIndex(tipoInsumo => tipoInsumo.TipoInsumo === tipoInsumos.TipoInsumo) !== -1) {
        this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(tipoInsumos.TipoInsumo.toString()));
        return true;
      }
    } else {
      if (tipoInsumos.TipoInsumo !== tInsumo.oldValue.TipoInsumo) {
        if (this.dataTipoInsumos.findIndex(tipoInsumo => tipoInsumo.TipoInsumo === tipoInsumos.TipoInsumo) !== -1) {
          this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(tipoInsumos.TipoInsumo.toString()));
          return true;
        }
      }
    }
    return false;
  }

  public accionStripRowBtn(rowContext: RowType, indexBtn: number) {
    try {
      switch (indexBtn) {
        case 1:
          this.beginAddRowByIndexNeo(this.gridTiposInsumos, rowContext.index);
          break;
        case 2:
          this.tipoMsg.mostrarQuestion((resp: boolean) => {
            if (resp) {
              this.eliminarTipoInsumos(rowContext);
            }
          }, this.mObjGenerico.getTranslationsQuestionBorrar(rowContext.data.TipoInsumo));
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public noPermitirBorrarMod(e: RowType) {
    if (ClsUtil.esNulo(e)) {
      return false;
    } else {
      return e.data.TipoInsumo > 3;
    }
  }

  public async onSelectionDropDown(opcion: string) {
    try {
      switch (opcion) {
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMasOpciones.ExportarExcel:
          const sms = await ClsUtil.exportarDatos(this.gridTiposInsumos, this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.TIPOS_INSUMOS'), this.excelExportService).then(sms => { return sms });
          this.tipoMsg.mostrarToast(this.mObjGenerico.getTranslationsSmsExportar(sms, this.gridTiposInsumos.selectedRows.length));
          break;
        case EnumMasOpciones.ExportarPDF:
          await ClsUtil.abrirVentanaPersonalizarPDF(
            this.gridTiposInsumos,
            this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.TIPOS_INSUMOS'),
            this.pdfExportService,
            this.crearCompDinamico,
            this.tipoMsg,
            this.mObjGenerico
          );
          break;
        case EnumMasOpciones.Actualizar:
          await this.cargarTiposDeInsumos();
          break;
        case EnumMasOpciones.LimpiarFiltroColumnas:
          this.clearInput();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public handleRowSelection() {
    this.gridTiposInsumos.nativeElement.focus();
  }

  public async datosPegadosDesdeExcel(datosPegado: any[]) {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.PEGANDO');
      const arrayTipos: ClsTipoInsumos[] = [];
      let dataDetalle: ClsColDetallePegado[];
      const colTipo: string = this.mObjGenerico.getTranslationsSubject('GRIDS.TIPOS_INSUMOS.COL_TIPO');
      const colDes: string = this.mObjGenerico.getTranslationsSubject('GRIDS.TIPOS_INSUMOS.COL_DESCRIPCION');
      this.mObjCopiado.columnasRequeridas = [colTipo, colDes];
      if (this.mObjCopiado.validarCamposRequeridos(datosPegado)) {
        let datos = this.mObjCopiado.procesarDatos(datosPegado, true);
        datos = this.mObjPegado.mergeDescriptions(datos, EnumNombresGrids.TipoInsumos);
        dataDetalle = this.mObjPegado.verificarDetallePegado(datos, [colTipo, colDes], [colTipo, colDes], EnumNombresGrids.TipoInsumos, this.mObjGenerico);
        if (dataDetalle.length > 0) {
          const vtnGenerico = this.crearCompDinamico.crearComponente(VtnGenericaComponent).instance as VtnGenericaComponent;
          vtnGenerico.queVtnEstaAbierta = 'PegadoEspecial';
          const vtnDiferencia = vtnGenerico.crearComponente(DetallePegadoComponent);
          vtnDiferencia.dataDetalle = dataDetalle;
          vtnDiferencia.open();
        } else {
          datos.forEach(x => {
            const valTipo: string = (x[colTipo] as string).toUpperCase();
            const valDes: string = ClsUtil.toSubstring(x[colDes], 40);
            const resp: any = this.mObjCRUDCatalogos.crearObjCatalogos(this.dataTipoInsumos, [valTipo, valDes], [colTipo, colDes], EnumTresPuntos.TiposDeInsumo, this.mObjGenerico);
            // si esNuevo es undifined, indica que existe pero no cambio nada
            if (!ClsUtil.esNulo(resp.esNuevo)) {
              if (resp.esNuevo) {
                this.gridTiposInsumos.addRow(resp.obj);
                arrayTipos.push(resp.obj);
              } else {
                this.gridTiposInsumos.updateCell(valDes, valTipo, 'DescripcionTipoInsumo');
                arrayTipos.push(resp.obj);
              }
            }
          });
          // invocar servicio para agregar o modificar siempre y cuando el arrayTipos tenga valor
          if (arrayTipos.length > 0) {
            await this.mObjCRUDCatalogos.agregarModificarCatalogo(arrayTipos, 'TipoInsumosRegistraActualiza2021');
          }
        }
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message);
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public async customKeydown(eventArgs) {
    const ctrl = eventArgs.ctrlKey;
    const key = eventArgs.keyCode;
    // Ctrl-C ||  Cmd-C
    if ((ctrl || eventArgs.metaKey) && key === 67) {
      await this.copiarData();
    }
  }

  public async copiarData() {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.COPIANDO');
      const msg: string = await ClsUtil.copiarDatosGrids(this.gridTiposInsumos, 'IdTipoInsumo', this.mObjGenerico);
      msg && this.tipoMsg.mostrarToast(msg);
    } catch (e) {
      throw new Error(e.message);
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public clearProps() {
    this.gridTiposInsumos.clearSort();
    this.gridTiposInsumos.clearFilter();
    this.gridTiposInsumos.clearSearch();
    this.gridTiposInsumos.deselectAllRows();
    this.clearInput();
  }

  public registroSeleccionado() {
    const rowSeleccionados: bigint[] = this.gridTiposInsumos.selectedRows;
    try {
      if (rowSeleccionados.length === 0) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_REGISTRO');
      }
      const rowData = this.gridTiposInsumos.getRowData(rowSeleccionados[0]);
      this.gridTiposInsumos.doubleClick.emit(rowData);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }
}
